import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import BulkFileUploader from "../../components/BulkFileUploader";
import PageTitle from "../../components/PageTitle";
import { getMaxDate, toggleMenu } from "../../utils/helpers";
import {
  API_BULK_UPLOAD_SYSTEM_LOGS,
  API_GET_SYSTEM_LOGS,
} from "../../config/Endpoints";
import { Toggle } from "../../v2/components/ui/toggle/toggle.tsx";
import {
  FiSettings,
  FiCalendar,
  FiDownload,
  FiInfo,
  FiFileText,
  FiMapPin,
} from "react-icons/fi";
import SortableTable from "../../components/SortableTable";
import { displayFormatDate } from "../../utils/helpers";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import NoRecordsAvailable from "../../components/NoRecordsAvailable";

const UploadSystemLogs = ({ title, description }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [unmappedSerials, setUnmappedSerials] = useState([]);
  const [activeTab, setActiveTab] = useState("invalid");
  const [override, setOverride] = useState(false);
  const [locationSync, setLocationSync] = useState(false);
  const modalBtnRef = React.useRef(null);
  const [invalidData, setInvalidData] = useState([]);
  const accessToken = Cookies.get("accessToken");
  const [overrideModalOpen, setOverrideModalOpen] = useState(false);
  const [checkingExistingData, setCheckingExistingData] = useState(false);

  const buildUploadUrl = () => {
    if (!selectedDate) return "";

    const formattedDate = selectedDate.toLocaleDateString("en-CA");
    const params = new URLSearchParams({
      date: formattedDate,
      fromTime: "11:00",
      overwriteSummaryForDay: true,
      locationSync: locationSync ? "true" : "false",
    });

    return `${API_BULK_UPLOAD_SYSTEM_LOGS}?${params.toString()}`;
  };

  const handleUploadSuccess = (responseData) => {
    const { invalidDetails, unmappedSerials } = responseData;

    if (
      (invalidDetails && invalidDetails.length > 0) ||
      (unmappedSerials && unmappedSerials.length > 0)
    ) {
      toast.success("File uploaded successfully!");
      setInvalidData(invalidDetails || []);
      setUnmappedSerials(unmappedSerials || []);
      setActiveTab("invalid");
      modalBtnRef.current.click();
    } else {
      toast.success("File uploaded successfully!");
    }

    setSelectedDate(null);
    setOverride(false);
    setLocationSync(false);
  };

  return (
    <>
      <div className="wrapper-body">
        <div className="page-heading">
          <div
            id="showMenuBtn"
            className="collapse-button"
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <PageTitle title={title} description={description} />
        </div>
        <form
          id="uploadForm"
          onSubmit={(e) => {
            e.preventDefault();
            if (!selectedDate) return;
          }}
        >
          <div
            className="card border-0 shadow-sm overflow-hidden"
            style={{ borderRadius: "16px" }}
          >
            <div className="row g-0" style={{ minHeight: "450px" }}>
              {/* Left Side - Configuration Area */}
              <div
                className="col-lg-4  border-end-lg border-bottom-md d-flex flex-column p-4"
                style={{ borderRight: "1px solid #dee2e6" }}
              >
                <div className="mb-2">
                  <h6
                    className="d-flex align-items-center gap-1 mb-3  theme-color"
                    style={{ fontSize: "15px" }}
                  >
                    <FiInfo size={15} /> Important Note
                  </h6>
                  <p className="text-muted m-0" style={{ fontSize: "13px" }}>
                    Please select the report date and review the parameters
                    before uploading the file.
                  </p>
                </div>

                <div className="w-100 mb-2 mt-3">
                  <div className="d-flex align-items-center gap-1 mb-2">
                    {" "}
                    <FiCalendar className="theme-color" size={15} />{" "}
                    <label className="label has-asterisk mb-0  ">
                      Select Report Date
                    </label>
                  </div>

                  <DatePicker
                    showIcon
                    toggleCalendarOnIconClick
                    selected={selectedDate}
                    onChange={(date) => {
                      setSelectedDate(date);
                      setOverride(false);
                    }}
                    maxDate={getMaxDate()}
                    dateFormat="MM/dd/yyyy"
                    placeholderText="mm/dd/yyyy"
                    isClearable
                    customInput={
                      <input
                        className="pr datepicker w-100 border rounded-2"
                        required
                      />
                    }
                  />
                </div>

                <div className="w-100 mb-2 mt-3">
                  <div className="d-flex align-items-center gap-1 mb-2">
                    {" "}
                    <FiMapPin className="theme-color" size={15} />{" "}
                    <label className="label  mb-0  ">
                      Sync Location
                    </label>
                  </div>

                  <Toggle
                    id="upload-system-logs-location-sync"
                    checked={locationSync}
                    onCheckedChange={setLocationSync}
                  />
                </div>

                <div className="mt-3 pt-3 border-top">
                  <h6
                    className="fw-bold mb-3"
                    style={{ fontSize: "13px", color: "#475569" }}
                  >
                    Download
                  </h6>
                  <a
                    href="../../../assets/SystemLogs_Bulk_Upload_Format.xlsx"
                    download
                    className="bulk-upload-link d-flex  gap-1"
                  >
                    {" "}
                    <FiDownload size={16} /> Bulk Upload Format
                  </a>
                </div>
              </div>

              {/* Right Side - Uploader area */}
              <div className="col-lg-8 d-flex flex-column p-2 p-lg-4">
                <div className="w-100 mx-auto" style={{ maxWidth: "480px" }}>
                  <div
                    className="uploader-container"
                    style={{ minHeight: "350px" }}
                  >
                    <BulkFileUploader
                      uploadUrl={buildUploadUrl()}
                      title={title}
                      description={description}
                      fileTypes={["xls", "xlsx"]}
                      buttonText="Proceed with Upload"
                      isDateSelected={
                        !overrideModalOpen && !checkingExistingData
                      }
                      onSuccess={handleUploadSuccess}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <button
        ref={modalBtnRef}
        data-bs-toggle="modal"
        data-bs-target="#upload-error-modal"
        style={{ display: "none" }}
      ></button>

      <div className="modal fade" id="upload-error-modal" tabIndex="-1">
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            {/* <div className="modal-header">
              <h5 className="modal-title text-center flex">Invalid Details</h5>
              <button className="btn-close" data-bs-dismiss="modal"></button>
            </div> */}

            <div className="modal-body">
              {/* Tabs UI */}
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "invalid" ? "active" : ""}`}
                    type="button"
                    onClick={() => setActiveTab("invalid")}
                  >
                    Invalid Details
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === "unmapped" ? "active" : ""}`}
                    type="button"
                    onClick={() => setActiveTab("unmapped")}
                  >
                    Unmapped Serials
                  </button>
                </li>
              </ul>

              {/* Tab Content */}
              <div
                style={{ maxHeight: "300px", overflowY: "auto" }}
                className="mt-3"
              >
                {activeTab === "invalid" && (
                  <ol>
                    {invalidData?.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ol>
                )}

                {activeTab === "unmapped" && (
                  <>
                    {unmappedSerials?.length > 0 ? (
                      <ol>
                        {unmappedSerials.map((serial, index) => (
                          <li key={index}>{serial}</li>
                        ))}
                      </ol>
                    ) : (
                      <p className="fs-5  text-secondary text-center">
                        No records available
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              <button className="theme-button bg-grey" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadSystemLogs;
